<template>
<div class="e-cc-application">

    <div class="c-form">
        
        <!-- SECTION ONE -->
        <section class="e-cc-application__section" id="section-one">

            <h2 class="e-cc-application__section-title" v-html="stepOneTitle"></h2>
            <div class="e-cc-application__section-content u-content" v-html="stepOneContent"></div>

            <div class="e-cc-application__fieldset">
                
                <p>Are you an existing SBS Bank member?</p>

                <div class="e-cc-application__member-fields">
                    
                    <div class="e-cc-application__field">
                        <input v-model="sbs_member" type="radio" name="sbs_member" value="Yes" id="sbs_member_yes" />
                        <label class="e-cc-application__field-radio-label" for="sbs_member_yes">Yes</label>                         
                    </div>

                    <div class="e-cc-application__field">
                        <input v-model="sbs_member" type="radio" name="sbs_member" value="No" id="sbs_member_no" />
                        <label class="e-cc-application__field-radio-label" for="sbs_member_no">No</label>
                    </div>

                </div>

            </div>

        </section>

        <!-- SECTION TWO -->
        <section class="e-cc-application__section" id="section-two" v-if="showSectionTwo">
            
            <div class="e-cc-application__section-content u-content">
                <p>To start your application, please click on get started button now</p>
            </div>
            <div class="e-cc-application__fieldset">
                <a :href="applicationLink" :disabled="applicationLink == ''":aria-disabled="applicationLink == ''" class="button button--primary e-cc-application__button">Get started</a>
            </div>

        </section>

        <!-- SECTION WRAPPER -->
        <section class="e-cc-application__section" id="section-three" v-if="showSectionThree">

            <div class="e-cc-application__section-inner">
                <div class="e-cc-application__section-three-graphic">
                    <img src="/_resources/app/client/assets/icons/creditcard-application-icon.svg" alt="" />
                </div>

                <div class="e-cc-application__content-wrapper">
                    <h2 class="e-cc-application__section-title" v-html="stepTwoTitle"></h2>
                    <div class="e-cc-application__section-content u-content" v-html="stepTwoContent"></div>
                </div>
            </div>

            <div class="e-cc-application__columns">

                <!-- SECTION THREE -->
                <div class="e-cc-application__column">

                    <div class="e-cc-application__fieldset">

                        <div class="e-cc-application__field-group">

                            <div class="e-cc-application__field firstname">
                                <label for="firstnames">First names</label>
                                <input v-model="firstnames" type="text" id="firstnames" @blur="validateTextField('firstnames')" />
                                <span v-if="form_errors.firstnames" class="error">{{ form_errors.firstnames }}</span>
                            </div>
                            <div class="e-cc-application__field lastname">
                                <label for="lastname">Last name</label>
                                <input v-model="lastname" type="text" id="lastname"  @blur="validateTextField('lastname')" />
                                <span v-if="form_errors.lastname" class="error">{{ form_errors.lastname }}</span>
                            </div>

                        </div>

                        <div class="e-cc-application__field">
                            <label for="membernumber">Member number</label>
                            <input v-model="member_number" type="text" id="membernumber" @blur="validateTextField('member_number')" />
                            <span v-if="form_errors.member_number" class="error">{{ form_errors.member_number }}</span>
                        </div>

                        <div class="e-cc-application__field">
                            <label>Date of birth</label>
                            
                            <div class="e-cc-application__dob-fields">

                                <div class="e-cc-application__field dob-day">                                
                                    <input v-model="dob_day" type="text" @blur="validateTextField('dob_day')" placeholder="DD" />
                                    <span v-if="form_errors.dob_day" class="error">{{ form_errors.dob_day }}</span>
                                </div>

                                <div class="e-cc-application__field dob-month">
                                    <input v-model="dob_month" type="text" @blur="validateTextField('dob_month')" placeholder="MM" />
                                    <span v-if="form_errors.dob_month" class="error">{{ form_errors.dob_month }}</span>
                                </div>

                                <div class="e-cc-application__field dob-year">
                                    <input v-model="dob_year" type="text" @blur="validateTextField('dob_year')" placeholder="YYYY" />
                                    <span v-if="form_errors.dob_year" class="error">{{ form_errors.dob_year }}</span>
                                </div>

                            </div>

                            <span class="description">Please enter your date of birth in the format DD MM YYYY</span>

                            <span class="error" v-if="!isValidDate">Please enter a valid date</span>
                        </div>

                        <button class="button button--primary" @click="stepThreeComplete">Send verification code</button>
                        <span v-if="form_errors.sms_verification_code" class="error">{{ form_errors.sms_verification_code }}</span>

                        <p v-if="messages.verification_sent" class="success">{{ messages.verification_sent }}</p>
                    </div>

                </div>
            

                <!-- SECTION FOUR -->
                <div class="e-cc-application__column" v-if="showSectionFour">

                    <h3 class="e-cc-application__section-title" v-html="stepThreeTitle"></h3>
                    <div class="e-cc-application__section-content u-content" v-html="stepThreeContent"></div>

                    <div class="e-cc-application__fieldset">

                        <div class="e-cc-application__field">
                            <label for="verification-code">Verification code</label>
                            <input type="text" id="verification-code" v-model="sms_verification_code" />
                            <span v-if="form_errors.code_check" class="error">{{ form_errors.code_check }}</span>	
                        </div>

                        <button class="button button--primary" @click="stepFourComplete">Verify</button>
                    </div>

                </div>

            </div>

        </section>

    </div>

</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import axios from "axios";

export default {
    name: "CreditCardApplicationForm",
    props: {
        elementId: {
            type: Number,
            required: true
        },
        stepOneTitle: {
            type: String,
            required: true,
        },
        stepOneContent: {
            type: String,
            required: true,
        },
        stepTwoTitle: {
            type: String,
            required: true,
        },
        stepTwoContent: {
            type: String,
            required: true,
        },
        stepThreeTitle: {
            type: String,
            required: true,
        },
        stepThreeContent: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            showSectionTwo: false,
            showSectionThree: false,
            showSectionFour: false,
            isValidDate: true,
            form_errors: {
                firstnames: '',
                lastname: '',
                member_number: '',
                dob_day: '',
                dob_month: '',
                dob_year: '',
                verifcation_code: '',
                code_check: ''
            },
            messages: {
                verification_sent: ''
            },
            applicationLink: '',
        }
    },
    mounted() {
        this.$store.dispatch('retrieveCreditCardApplicationContent', this.elementId);
        this.$store.dispatch('retrieveQikBaseURL');
    },
    watch: {
        sbs_member(value) {
            // generate Qik token for urls and sms code
            this.handleGenerateToken();
            this.showSectionTwo = value === "No";
            this.showSectionThree = value !== "No";
            this.showSectionFour = false;
        },
    },
    computed: {
        ...mapFields([
            "config.baseURL",
            "config.qikBaseURL",
            "creditcardApplication.content",
            "creditcardApplication.submission.sbs_member",
            "creditcardApplication.submission.firstnames",
            "creditcardApplication.submission.lastname",
            "creditcardApplication.submission.member_number",
            "creditcardApplication.submission.dob_day",
            "creditcardApplication.submission.dob_month",
            "creditcardApplication.submission.dob_year",
            "creditcardApplication.submission.sms_verification_code",
            "qik_token",
        ]),
        ...mapState(['qik_token', 'qik_errors']),
    },
    methods: {
        ...mapActions(['generateQikToken']),

        async handleGenerateToken() {
            const token = await this.generateQikToken();

            if (token) {
                this.applicationLink = this.buildApplicationLink();
            }
        },

        validateTextField(fieldname) {
            const fieldValidations = {
                firstnames: { required: "First names is required" },
                lastname: { required: "Last name is required" },
                // Validate member number to be exactly 6 digits
                member_number: { valid: val => this.isValidMemberNumber(val) },
                dob_day: { valid: val => this.isValidDOB(val, 1, 31, "Invalid day (1-31)") },
                dob_month: { valid: val => this.isValidDOB(val, 1, 12, "Invalid month (1-12)") },
                dob_year: { valid: val => this.isValidDOB(val, 1925, new Date().getFullYear(), `Enter a valid year (1925-${new Date().getFullYear()})`) }
            };

            if (fieldname) {
                const field = fieldValidations[fieldname];
                this.form_errors[fieldname] = field.required ? !this[fieldname] ? field.required : "" : field.valid(this[fieldname]);
                return !this.form_errors[fieldname]; // Return true if no error, false otherwise
            } else {
                // Validate all fields at once
                let isValid = true;
                Object.keys(fieldValidations).forEach(key => {
                    const field = fieldValidations[key];
                    this.form_errors[key] = field.required ? !this[key] ? field.required : "" : field.valid(this[key]);
                    if (this.form_errors[key]) isValid = false;
                });
                return isValid;
            }
        },
        isValidMemberNumber(value) {
            const numValue = value.trim(); // Remove any leading/trailing spaces
            // Ensure it's a valid number and contains exactly 6 digits
            if (!/^\d{6}$/.test(numValue)) {
                return "Member number must be exactly 6 digits";
            }
            return ""; // No error
        },
        isValidDOB(value, min, max, errorMessage) {
            const numValue = value.trim(); // Remove any leading/trailing spaces
            // Ensure it's a valid number and contains only digits
            if (!/^\d+$/.test(numValue)) {
                return errorMessage; // Must be digits only
            }

            const num = parseInt(numValue);
            return num < min || num > max ? errorMessage : ""; // Return the error message if it's out of range
        },
        validateDOB() {
            // Validate the whole DOB
            this.isValidDate = this.dob_day && this.dob_month && this.dob_year;
        },        
        isValidStepThree() {
            return this.validateTextField() && this.isValidDate;
        },
        stepThreeComplete() {
            if (this.isValidStepThree()) {
                console.log("Step three complete");
                // make call to API to generate verification code
                let self = this;
                this.generateSmsCode(self);
                
                // If the request was successful, show a confirmation message
                // self.messages.verification_sent = "A verification code has been sent to your phone.";
                // self.showSectionFour = true; // Proceed to the next step
            }
        },
        stepFourComplete() {
            
            if (this.sms_verification_code) {

                console.log("Verifying verification code");

                let self = this;

                // make call to API to verify verification code
                var verified = this.verifySmsCode(self);

                if (verified) {
                    // redirect user to form submission page
                    // include params to auto-populate the form ??

                    let applicationLink = this.buildApplicationLink();

                    // Redirect to the application link in the current tab
                    window.location.href = applicationLink;

                    // console.log( applicationLink );

                } else {
                    // handle error
                    this.form_errors.code_check = "The SMS verification code is incorrect. Please try again.";
                }

            } else {
                this.form_errors.code_check = "Please enter the verification code.";
            }
        },
        async generateSmsCode(self) {
            console.log("Generating verification code");

            // Clear previous errors
            self.form_errors.member_number = "";
            self.form_errors.sms_verification_code = "";
            self.successMessage = "";

            const baseURL = window.location.origin + window.location.pathname;
                
            // Trigger the PHP function using Axios to call the PHP endpoint
            try {                
                
                // format form data for POST request
                const payload = {
                    customerNumber: self.member_number,
                    firstNames: self.firstnames,
                    surname: self.lastname,
                    dateOfBirth: `${self.dob_day}-${self.dob_month}-${self.dob_year}`
                };

                // Make the API call to the server-side function
                const response = await axios.post(`${baseURL}/generateVerificationCode`, payload);

                console.log("RESPONSE:", response);

                if (response.data.error) {
                    // Handle any errors returned by the PHP function
                    self.form_errors.member_number = `Error: ${response.data.error}`;
                    return;
                }

                // If the request was successful, show a confirmation message
                self.messages.verification_sent = "A verification code has been sent to your phone.";
                self.showSectionFour = true; // Proceed to the next step

            } catch (error) {
                // console.error("AXIOS ERROR:", error);

                // Handle network or server errors
                self.form_errors.sms_verification_code =
                    error.response && error.response.data && error.response.data.error
                        ? `Error: ${error.response.data.error}`
                        : "Error generating verification code. Please try again.";

                self.showSectionFour = false; // Ensure section does NOT show on error
                
            }
        },
        async verifySmsCode(self) {

            // Clear previous errors
            self.form_errors.sms_verification_code = "";
            const baseURL = window.location.origin + window.location.pathname;

            try {
                if (!self.sms_verification_code) {
                    self.form_errors.sms_verification_code = "Please enter the verification code.";
                    return;
                }

                // Make the API call to verify the code
                // data saved in the php session
                const response = await axios.post(`${baseURL}/verifySmsCode`);

                // Handle error response from the API
                if (response.data.error) {
                    self.form_errors.code_check = `Error: ${response.data.error}`;
                    return false;
                }

                // Handle successful response
                if (response.data.success) {
                    // return to stepFourComplete()
                    return true;
                } else {
                    self.form_errors.code_check = "Unknown error occurred, please try again.";
                    return false;
                }

            } catch (error) {
                self.form_errors.code_check =
                    error.response && error.response.data && error.response.data.error
                        ? `Error: ${error.response.data.error}`
                        : "Error verifying the code. Please try again.";

                        self.sms_verification_code = ""; // Clear the verification code field
                return false;
            }
        },
        buildApplicationLink() {

            let baseURL = this.qikBaseURL + '/Qik/Qikdealer/Default_Credit_Card_Application.asp';

            // build URL
            let params = [                
                'AutoActivateDlr=680102',
                'ProdType=S01',
                'ProdCode=R480',
                'AppChannel=ONL',
                `TokenID=${this.qik_token}`                
            ];

            if (this.member_number) {
                params.push(`MemberID=${this.member_number}`);
            }

            params.push('Action=Global');

            return `${baseURL}?${params.join('&')}` + '#/start/step1?product=S01';
        },
    }
}</script>

<style scoped>
.error {
    color: red;
    font-size: 16px;
    display: block;
    margin-top: 2px;
}
</style>